import { Stack, Group, Button } from "@mantine/core";
import { IconArrowLeft } from "@tabler/icons-react";
import { Link } from "react-router-dom";
import { CptFrequencyReportContent } from "./CptFrequencyReportContent";

export default function CptFrequencyReportPage() {
  return (
    <Stack gap="lg" p="md">
      <Group>
        <Button
          component={Link}
          to="/reports"
          variant="subtle"
          leftSection={<IconArrowLeft size={16} />}
        >
          Reports
        </Button>
      </Group>
      <CptFrequencyReportContent />
    </Stack>
  );
}
